import type { BlockComponentProps } from "./shared"

export function DividerBlock({ content, resolved }: BlockComponentProps) {
  const style = (content?.style as "line" | "dots" | "thick") ?? "line"
  const hrClass =
    style === "thick"
      ? "border-t-4 my-8"
      : style === "dots"
        ? "border-none my-8 flex justify-center gap-1"
        : "my-8"
  const divSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 @sm:px-6 @md:px-8"
  return (
    <section className={divSectionClass} style={resolved.sectionStyle}>
      {style === "dots" ? (
        <div className={hrClass} aria-hidden>
          <span className="w-2 h-2 rounded-full bg-muted-foreground/50" />
          <span className="w-2 h-2 rounded-full bg-muted-foreground/50" />
          <span className="w-2 h-2 rounded-full bg-muted-foreground/50" />
        </div>
      ) : (
        <hr className={`border-t border-muted-foreground/30 ${hrClass}`} />
      )}
    </section>
  )
}
